import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.4884 15.8952V8.98962"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.5114 15.8951V9.80627"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.49475 13.7828L1.57347 14.7517C1.64976 15.3216 2.11479 15.7588 2.68876 15.7935C4.1532 15.8821 6.94804 16.0335 8.95154 16.0335C10.9117 16.0335 13.6294 15.8886 15.1174 15.7994C15.7331 15.7625 16.2183 15.2646 16.2442 14.6484L16.5335 7.76096V5.87518"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.4549 3.68681C16.5596 2.63246 16.5598 2.05336 16.4549 1.04505C15.4466 0.940275 14.8676 0.940335 13.8132 1.04505"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.46655 10.8321C2.92334 8.69349 4.62737 6.9895 6.76604 5.53278L9.36656 8.13331C11.8759 6.30179 14.4364 3.64412 16.268 1.13477"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
) as React.FC;
